export function removeTagsInPreview(html: string) {
  const removeButtons = html.replace(/<button class="token-remove"[^>]*>.*?<\/button>/g, '')

  const cleanHtml = removeButtons.replace(/<span[^>]*class="token-node"[^>]*>(.*?)<\/span>/g, '$1')

  const removeCurlyBrackets = cleanHtml.replace(/{{.*?}}/g, '')

  const removeSquareBrackets = removeCurlyBrackets.replace(/\[\[\/?.*?\]\]/g, '')

  return removeSquareBrackets
}

export function simpleHtmlPreview(html: string) {
  return html
    .replace(/<br>/g, '\n')
    .replace(/<button[^>]*>.*?<\/button>/g, '')
    .replace(/<[^>]*>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
}
